<template>
  <v-layout row justify-center>
    <v-dialog v-model="model" persistent max-width="600px">
      <v-card>
        <v-form ref="form">
          <v-card-title>
            <span class="headline">Lägg till kommentar</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-textarea
                    v-model.trim="comment"
                    label="Kommentar"
                    :rules="commentRules"
                    :counter="500"
                    required
                    @focus="resetValidation"
                    @blur="resetValidation"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="model = false">Avbryt</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Spara kommentar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      comment: '',
      errorMessage: '',
      commentRules: [
        (v) => !!v || 'Fältet är obligatoriskt',
        (v) => v.length <= 500 || 'Kommentaren får max vara 500 tecken',
      ],
    };
  },
  computed: {
    model: {
      set(v) {
        this.$emit('input', v);
        if (v === false) {
          this.resetForm();
          this.resetValidation();
        }
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$emit('save', this.comment);

      this.resetForm();
      this.resetValidation();
      this.model = false;
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    resetForm() {
      this.comment = '';
    },
  },
};
</script>
